<template>
  <div class="communities-container">
    <create-community-bar :communities-infos="communitiesInfos" />
    <div class="filter-container">
      <div class="search-name-container">
        <div class="search-name">
          <input type="text"
                 data-cy="search-community-input"
                 class="search-input"
                 v-model="communityNameSearch"
                 :placeholder="$t('community.communities.searchForCommunity')"
          />
          <img @click="resetSearch()"
               alt="close-icon"
               class="close-icon"
               src="@/assets/CloseMed.svg"
          />
          <img alt="search-icon"
               class="search-icon"
               src="@/assets/SearchIcon.svg"
          />
        </div>
        <div class="result-number">
          <span class="number">{{ $tc('community.communities.results', communities.length, { count: communities.length }) }}</span>
        </div>
      </div>
      <sorting-menu type="communities"
                    v-if="communities.length !== 0 || currentSort === 'popularity'"
      />
    </div>
    <div class="tiles-container" v-if="isLoaded && communities.length > 0">
      <div v-for="community in communities"
           :key="community.id"
           class="community-block"
           data-cy="community-card"
      >
        <community-tile :community="community" />
      </div>
    </div>
    <infinite-loading v-if="!isLoaded"
                      :identifier="infiniteLoadingId"
                      @infinite="loadCommunities"
    />
    <span v-if="communities.length === 0">
      <logo-background />
    </span>
  </div>
</template>

<script>
import CommunityTile from './CommunityTile'
import LogoBackground from '@/components/shared/LogoBackground'
import CreateCommunityBar from './CreateCommunityBar'
import SortingMenu from '@/components/shared/SortingMenu'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'Communities',
  components: { CommunityTile, LogoBackground, CreateCommunityBar, SortingMenu, InfiniteLoading },
  data() {
    return {
      communityNameSearch: '',
      isLoaded: false
    }
  },
  async created() {
    // await so we are sure communities loading is using the right filter
    await this.$store.dispatch('filterCommunities', 'all')
    await this.$store.dispatch('resetSortCommunities')
    this.$store.dispatch('fetchCommunitiesInfo')
    this.$store.dispatch('fetchUserJoinRequests')
    this.$store.dispatch('fetchUserOwnerRequests')
    this.$store.dispatch('fetchOwnerOwnerRequests')
    this.$store.dispatch('fetchUserCommunities')
  },
  methods: {
    resetSearch() {
      this.communityNameSearch = ''
    },
    async loadCommunities() {
      // no await, because loading is progressive, and we want to display data as soon as possible,
      // not when everything is loaded
      this.$store.dispatch('fetchCommunities')
      this.isLoaded = true
    }
  },
  computed: {
    communities() {
      if (this.communityNameSearch) {
        return this.$store.getters.filteredCommunities.filter(community => community.name.toUpperCase().indexOf(this.communityNameSearch.toUpperCase()) >= 0)
      } else {
        return this.$store.getters.filteredCommunities
      }
    },
    communitiesInfos() {
      return this.$store.getters.communitiesInfos
    },
    currentSort() {
      return this.$store.getters.communitiesSort
    },
    infiniteLoadingId() {
      return this.$store.getters.communityFilter + new Date()
    }
  }
}
</script>

<style scoped lang="scss">

.filter-container {
  display: flex;
  justify-content: space-between;

  @media (max-width: $small) {
      justify-content: center;
      flex-wrap:wrap;
      margin: 0;
  }

  .search-name-container {
    display: flex;
    align-items: baseline;
    margin: 0 10px;

    @media (max-width: $small) {
       width:100vw;
       justify-content: center;
       margin: 0;
       margin-bottom: 10px;
       flex-wrap:wrap;
    }

    .search-name {
      position: relative;

      .search-input {
        border: 1px solid #D8D8D8;
        border-radius: 3px;
        min-height: 31px;
        width: 326px;
        padding: 0 60px 0 10px;
        font-size: 15px;

        @media (max-width: $small) {
           width: 260px;
           padding: 0;
           padding-left: 10px;
        }
      }

      .close-icon {
        position: absolute;
        right: 40px;
        top: 5px;
        cursor: pointer;
      }

      .search-icon {
        position: absolute;
        right: 10px;
        top: 5px;
      }
    }

    .result-number {
      margin-left: 20px;
      color: $black-color;
      font-size: 15px;

      .number {
        font-weight: 700;
      }
    }
  }

}

.communities-container {
  width: 1250px;
  @media (max-width: $small) {
    width: 100%;
  }
  .down {
    #list {
      top: 270px !important;
    }
  }
}

.tiles-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;

  @media (max-width: 1247.5px) {
    justify-content: center;
    margin-bottom: 50px;
  }
}

.community-block {
  height: 434px;
  background: white;
  margin: 10px;
  display: flex;
  cursor: pointer;
  text-align: center;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
  @media (max-width: $small) {
    max-width: 100%;
    margin: 10px auto 10px auto;

  }
  &:hover {
    box-shadow: 2px 2px 30px 0 rgba(3, 3, 3, 0.2);
  }

  img {
    width: 606px;
    height: auto;
  }
}

</style>
